export const URL =
  process.env.NODE_ENV == "production"
    ? `${window.location.protocol}//${window.location.hostname}:${
        window.location.protocol === "http:" ? 8000 : 8443
      }`
    : "http://localhost:8000";
//export const URL = "http://mt.odis.co.kr:8000";

export const DELETE_KEY = "infotech";

//Login

export const LOGIN = URL + "/users/login";

//user

export const GET_USER_LIST = URL + "/users";
export const MAKE_USER = URL + "/users";
export const DELETE_USER = URL + "/users/";

//location
export const GET_LOCATION_LIST = URL + "/locations";
export const MAKE_LOCATION = URL + "/locations";
export const DELETE_LOCATION = URL + "/locations/";

//contract

export const UPDATE_CONTRACT = URL + "/locations/contract";

// detail

export const UPDATE_DETAIL = URL + "/locations/detail";
export const SET_DETAIL = URL + "/locations/detail/set";
//histroy

export const DELETE_HISTORY = URL + "/locations/history/";

//server

export const GET_SERVER_LIST = URL + "/servers";
export const ADD_SERVER = URL + "/servers";
export const DELETE_SERVER = URL + "/servers";
export const UPDATE_SERVER = URL + "/servers";

//sms

export const GET_SMS_LIST = URL + "/sms";

//corona

export const GET_CORONA_LIST = URL + "/corona";
export const ADD_CORONA = URL + "/corona";

//copy

export const COPY_CHECK_URL = URL + "/copy";

//ip

export const IP_URL = URL + "/ip";

//calculate

export const CALCULATE_URL = URL + "/calculate";
export const CALHISTORY_URL = URL + "/calHistory";

//attendance
export const GET_ATTENDANCE_LIST = URL + "/attendance";
export const ADD_ATTENDANCE = URL + "/attendance";
export const UP_ATTENDANCE = URL + "/attendance";
export const USER_UPDATE_AUTOCHK = URL + "/users";

//logininfo

export const LOGININFO_URL = URL + "/logininfos";
